import React, { useEffect, useState } from 'react';
import Select from 'components/Select';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { thunkFetchPhotobooths } from '@/redux/actions/aiPhotobooth.action';

const AIPhotoboothPicker = ({ handlePickItem, getPhotobooths, aiPhotobooths, aiPhotobooth }) => {
	const { eventID } = useParams();
	const [selectedAIPhotobooth, setSelectedAIPhotobooth] = useState([]);

	const handleSetAIPhotoBoothRoute = sessionId => {
		if (aiPhotobooths) {
			const photobooth = aiPhotobooths.find(p => Number(p.id) === Number(sessionId));
			handlePickItem({
				route: `/ai-photobooth/${sessionId}`,
				name: photobooth ? photobooth.name : 'Photobooth',
			});
		}
	};
	useEffect(() => {
		getPhotobooths(eventID);
	}, [eventID]);

	useEffect(() => {
		if (aiPhotobooth && aiPhotobooth.includes('ai-photobooth')) {
			const aiPhotoboothKey = aiPhotobooth.split('/');
			const aiPhotoboothID = +aiPhotoboothKey[aiPhotoboothKey.length - 1];
			setSelectedAIPhotobooth([aiPhotoboothID]);
		}
	}, [aiPhotobooth]);

	if (!aiPhotobooths) return null;

	return (
		<div>
			<Select
				data={aiPhotobooths}
				value={selectedAIPhotobooth || []}
				placeholder="Select an AI photobooth"
				onChange={handleSetAIPhotoBoothRoute}
			/>
			{/* <OldSelect
				placeholder="Select an AI photobooth"
				style={{ width: '100%' }}
				onChange={handleSetAIPhotoBoothRoute}
			>
				{aiPhotobooths.map(photobooth => (
					<OldSelect.Option value={`${photobooth.id}`} key={`${photobooth.id}${photobooth.name}`}>
						{photobooth.name}
					</OldSelect.Option>
				))}
			</OldSelect> */}
		</div>
	);
};

const msp = ({ aiPhotobooths }) => ({ aiPhotobooths });
const mdp = dispatch => ({
	getPhotobooths: eventID => dispatch(thunkFetchPhotobooths(eventID)),
});

export default connect(msp, mdp)(AIPhotoboothPicker);
